module.exports = __webpack_public_path__ + "img/35.cbd87940.jpg";